// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/UmbrellaAdmins/index.css
// module id = 2566
// module chunks = 0